<template src="./manholePage.html"></template>

<script>
import pipe from '../../../../../components/pipe/pipe.vue';
import reportMixin from '../../../../../js/reportMixin';

export default {
    name: 'manhole-page',
    props: [
        'observations', 
        'headerInputs', 
        'sessionFields', 
        'reportTitle', 
        'headerOptionsAndValues'
    ],
    components: {'pipe': pipe,},
    mixins: [reportMixin],
    data() {
        return {
            connectionPoints: [],
            connectionPointsTableItems: []
        }
    },
    computed: {
        imagePath() {
            return window.path;
        },
        session() {
            return this.$store.state.SessionsModule.Session;
        },
        reportSettings() {
            return this.$store.state.ReportsModule.ReportSettings
        },
    },
    methods: {
        manholeConnectionImageStyle(observation) {
            let rotation = observation.position * 30;
            let leftPositionsMap = new Map([
                [0, 28],
                [1, 70],
                [2, 100],
                [3, 105],
                [4, 100],
                [5, 70],
                [6, 28],
                [7, -15],
                [8, -50],
                [9, -55],
                [10, -50],
                [11, -20],
                [12, 28]
            ]);

            let topPositionsMap = new Map([
                [0, -25],
                [1, -15],
                [2, 10],
                [3, 55],
                [4, 85],
                [5, 115],
                [6, 125],
                [7, 115],
                [8, 85],
                [9, 55],
                [10,10],
                [11, -15],
                [12, -25]
            ]);

            return { 
                transform: 'rotate(' + rotation + 'deg)', 
                left: leftPositionsMap.get(observation.position) + 'px', 
                top: topPositionsMap.get(observation.position) + 'px'
            }
        },

        manholeConnectionTextStyle(observation) {

            let textAlign = "start";
            let leftPositionsMap = new Map([
                [0, 78],
                [1, 170],
                [2, 230],
                [3, 240],
                [4, 225],
                [5, 175],
                [6, 78],
                [7, -165],
                [8, -225],
                [9, -239],
                [10, -225],
                [11, -170],
                [12, 78]
            ]);

            let topPositionsMap = new Map([
                [0, -65],
                [1, -45],
                [2, 10],
                [3, 92],
                [4, 160],
                [5, 210],
                [6, 230],
                [7, 210],
                [8, 160],
                [9, 92],
                [10, 10],
                [11, -45],
                [12, -65]
            ]);

            if (observation.position > 6 && observation.position < 12) {
                textAlign = "end";
            }

            return { 
                left: leftPositionsMap.get(observation.position) + 'px', 
                top: topPositionsMap.get(observation.position) + 'px', 
                textAlign: textAlign
            }
        }
    },
    created() {
        this.observations.forEach((observation) => {
            if (observation.FaultCode === 'C') {
                
                observation.Fields.forEach((field) => {
                if (field.Value) {
                    if (field.Name === 'AtFrom') {
                        observation.position = parseInt(field.Value);
                        if (observation.position !== NaN) {
                            if (this.connectionPoints.some(x=> x.position === observation.position) === false)
                            this.connectionPoints.push(observation);
                        }
                    }
                    else if (field.Name === 'Dim4') {
                        observation.direction = field.Value;
                    }
                }

            })

            observation.Distance = parseFloat(observation.Distance);
            if (observation.Distance !== NaN) {
                if (Number.isInteger(observation.Distance ) == false) {
                    observation.Distance = observation.Distance.toFixed(1);
                }
            }
                    
              this.connectionPointsTableItems.push(observation);
            }
            
        }) 
    }
}

</script>
